module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "references"
    }
  }, [_c('h1', [_vm._v("References")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Aas K (1989):")]), _vm._v(" To win with a wheeze. Mediglobe, Fribourg. ISBN: 28823900178.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Kopot A")]), _vm._v(" "), _c('strong', [_vm._v("(2014):")]), _vm._v(" AK lectures: "), _c('a', {
    attrs: {
      "href": "http://www.aklectures.com/subject/organic-chemistry",
      "target": "_blank"
    }
  }, [_vm._v("Organic chemistry")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Kopot A")]), _vm._v(" ("), _c('strong', [_vm._v("2014):")]), _vm._v(" AK lectures: "), _c('a', {
    attrs: {
      "href": "http://www.aklectures.com/subject/general-chemistry",
      "target": "_blank"
    }
  }, [_vm._v("General chemistry")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Lewis RG et al (1999):")]), _vm._v(" Distribution of pesticides and polycyclic aromatic hydrocarbons in house dust as a function of particle size. Environ Health Perspect; 107: 721 – 26"), _c('a', {
    attrs: {
      "href": "http://www.ncbi.nlm.nih.gov/pmc/articles/PMC1566465/pdf/envhper00514-0069.pdf",
      "target": "_blank"
    }
  }, [_vm._v(". Free article")]), _vm._v(".")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Noy D (1987):")]), _vm._v(" Persoonlijke blootstelling aan NO"), _c('sub', [_vm._v("2")]), _vm._v(" in Nederland. Publikatiereeks Lucht 62, Ministerie VROM ("), _c('em', [_vm._v("in Dutch")]), _vm._v(").")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("O’Donnell B (2014):")]), _vm._v(" "), _c('em', [_vm._v("Exposure")]), _vm._v(" – the hidden threats that are making us sick. Horizon, the "), _c('a', {
    attrs: {
      "href": "http://horizon-magazine.eu/article/exposure-hidden-threats-are-making-us-sick_en.html",
      "target": "_blank"
    }
  }, [_vm._v("EU Research & Innovation Horizon Magazin"), _c('strong', [_vm._v("e")])]), _c('strong', [_vm._v(",")]), _vm._v(" 01 September 2014.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Pääbo S (2014):")]), _vm._v(" The human condition – a molecular approach. Cell; 157: 216 – 26. "), _c('a', {
    attrs: {
      "href": "http://www.cell.com/cell/fulltext/S0092-8674(13)01605-X",
      "target": "_blank"
    }
  }, [_vm._v("Free article.")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "http://www.ncbi.nlm.nih.gov/pubmed?term=Sankararaman%20S%5BAuthor%5D&cauthor=true&cauthor_uid=24476815",
      "target": "_blank"
    }
  }, [_c('strong', [_vm._v("Sankararaman S")])]), _vm._v(" et al "), _c('strong', [_vm._v("(2014):")]), _vm._v(" The landscape of Neanderthal ancestry in present-day humans"), _c('strong', [_vm._v(".")]), _vm._v(" Nature; 507:354 – 7. "), _c('a', {
    attrs: {
      "href": "http://www.ncbi.nlm.nih.gov/pmc/articles/PMC4072735/",
      "target": "_blank"
    }
  }, [_vm._v("Free Article")]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e728c34","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch008.vue
// module id = 84
// module chunks = 0